import * as React from 'react';
import {Link} from "react-router-dom";

interface PrimaryButtonProps {
    label: string;
    loading: boolean;
    onClick: (event: any) => void;
}

export const PrimaryButton: React.FC<PrimaryButtonProps> = (props) => {

    return (
            <Link to={'#'}
                  className="plainButton"
                  style={{
                      clear: 'none',
                  }}
                  onClick={(event: any) => props.onClick(event)}>
                {props.loading && (<span className="plainButtonSpinner"></span>)}

                {!props.loading && (<span>{props.label}</span>)}
            </Link>
    );
};

export default PrimaryButton;
